import { ChangeDetectionStrategy, Component, effect, Signal } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonV3Component } from '@gea/digital-ui-lib';
import { Divider } from 'primeng/divider';
import { WorktreeDeleteCheckResponse } from '../data-maintenance.model';

export interface DeleteWorkspaceDialogData {
  workspace: string;
  checkResult: WorktreeDeleteCheckResponse;
  isDeleting: Signal<boolean>;
  onConfirmDelete: () => void;
}

@Component({
  selector: 'app-delete-workspace-dialog',
  standalone: true,
  imports: [ButtonV3Component, Divider],
  templateUrl: './delete-workspace-dialog.component.html',
  styleUrl: './delete-workspace-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteWorkspaceDialogComponent {
  workspace: string;
  checkResult: WorktreeDeleteCheckResponse;
  blockedMessage: string;
  isDeleting: Signal<boolean>;
  private readonly onConfirmDelete: () => void;

  constructor(
    private readonly dialogRef: DynamicDialogRef,
    private readonly dialogConfig: DynamicDialogConfig<DeleteWorkspaceDialogData>
  ) {
    const data = dialogConfig.data!;
    this.workspace = data.workspace;
    this.checkResult = data.checkResult;
    this.isDeleting = data.isDeleting;
    this.onConfirmDelete = data.onConfirmDelete;
    this.blockedMessage = this.checkResult.blockingPullRequestId
      ? 'You cannot delete the workspace as there is an active PR on this workspace, please delete the PR first and then try deleting it.'
      : this.checkResult.reason ?? 'This workspace cannot be deleted.';

    effect(() => {
      this.dialogConfig.dismissableMask = !this.isDeleting();
    });
  }

  confirm(): void {
    if (this.isDeleting()) return;
    this.onConfirmDelete();
  }

  cancel(): void {
    if (this.isDeleting()) return;
    this.dialogRef.close();
  }
}
